import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import axiosScoring from 'config/axiosScoring';

import axios from 'axios';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Spinner,
} from 'reactstrap';
import { KeywordGenerationButton } from '../TextDisplaySidebar/KeywordGenerationButton';
import {
  setRedactionData,
  setIntialScoreData,
  setIntialScoreLoading,
} from 'store/Writer/RedactionData';
import { keywordsAutoGeneration } from 'utils/KeywordsAutoGeneration/keywordsAutoGeneration';
import { transformToKeywordFrequencyMap } from 'helpers/FormatKeywordsHelper';
import { writerRedactionDataSelector } from 'store/Writer/RedactionData';
import './RedactionModal.css';
import { UncontrolledTooltip } from 'reactstrap';

const RedactionModal = ({
  isOpen,
  onClose,
  orderId,
  orderSiloName,
  orderWebsite,
  language,
  maxWords,
  t = (key) => key,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [formData, setFormData] = useState({
    keyword: '',
    url: '',
    semanticGap: '',
    internalLinking: '',
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isRetrieving, setIsRetrieving] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('danger');

 
  const [semanticGapValidation, setSemanticGapValidation] = useState({
    isValid: false,
    message: '',
    isChecked: false
  });

 
  const [keywords, setKeywords] = useState('');
  const [combinedKeywords, setCombinedKeywords] = useState('');
  const [combinedKeywordsList, setCombinedKeywordsList] = useState([]);
  const [websites, setWebsites] = useState('');
  const [isReadyToRedirect, setIsReadyToRedirect] = useState(false);

  const [errorSuccessMsg, setErrorSuccessMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorSuccess, setErrorSuccess] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const { isDataAvailable } = useSelector(writerRedactionDataSelector);

  useEffect(() => {
    if (isReadyToRedirect && isDataAvailable) {
      history.push('/Redacteur/TextDetails');
      setIsReadyToRedirect(false);
    }
  }, [isReadyToRedirect]);

 
  const validateSemanticGapFormat = (value) => {
    if (!value.trim()) {
      return {
        isValid: false,
        message: '',
        isChecked: false
      };
    }

    try {
      
      const patterns = [
        /^[^(),\n]+ *\(\d+\)$/,   
        /^[^(),\n]+\s*\(\s*\d+\s*\)$/  
      ];

   
      const items = value.split(/[,\n]/).map(item => item.trim()).filter(item => item.length > 0);
      
      if (items.length === 0) {
        return {
          isValid: false,
          message: t('Le format doit être: Mot clé(fréquence), séparé par virgule ou retour à la ligne'),
          isChecked: true
        };
      }

    
      for (const item of items) {
        const trimmedItem = item.trim();
        if (!trimmedItem) continue;

   
        const isValidItem = patterns.some(pattern => pattern.test(trimmedItem));
        
        if (!isValidItem) {
          return {
            isValid: false,
            message: t('Format incorrect'),
            isChecked: true
          };
        }

     
        const keywordPart = trimmedItem.split('(')[0].trim();
        if (!keywordPart) {
          return {
            isValid: false,
            message: t('Le mot-clé ne peut pas être vide'),
            isChecked: true
          };
        }

     
        const frequencyMatch = trimmedItem.match(/\((\d+)\)/);
        if (!frequencyMatch || parseInt(frequencyMatch[1]) <= 0) {
          return {
            isValid: false,
            message: t('La fréquence doit être un nombre positif'),
            isChecked: true
          };
        }
      }

     
      try {
        const transformed = transformToKeywordFrequencyMap(value);
        if (!transformed || Object.keys(transformed).length === 0) {
          return {
            isValid: false,
            message: t('Format non compatible avec le système'),
            isChecked: true
          };
        }
      } catch (error) {
        return {
          isValid: false,
          message: t('Format non compatible avec le système'),
          isChecked: true
        };
      }

      return {
        isValid: true,
        message: t('Format valide ✓'),
        isChecked: true
      };

    } catch (error) {
      return {
        isValid: false,
        message: t('Format incorrect'),
        isChecked: true
      };
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

 
    if (name === 'semanticGap') {
      const validation = validateSemanticGapFormat(value);
      setSemanticGapValidation(validation);
    }

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

    if (alertMessage) {
      setAlertMessage('');
    }
  };

  const validateForm = () => {
    const newErrors = {};

  
    if (!formData.keyword.trim()) {
      newErrors.keyword = t('Le mot clé est obligatoire');
    }

    
    if (!formData.semanticGap.trim()) {
      newErrors.semanticGap = t('Le GAP sémantique est obligatoire');
    } else if (!semanticGapValidation.isValid) {
      newErrors.semanticGap = semanticGapValidation.message;
    }

 
    if (formData.url.trim()) {
      try {
        new URL(formData.url);
      } catch (error) {
        newErrors.url = t("Format d'URL invalide");
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 
  const isFormValid = () => {
    return (
      formData.keyword.trim() &&
      formData.semanticGap.trim() &&
      semanticGapValidation.isValid &&
      (!formData.url.trim() || isValidUrl(formData.url))
    );
  };

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      setAlertMessage(t('Veuillez corriger les erreurs dans le formulaire'));
      setAlertType('danger');
      return;
    }

    setIsLoading(true);
    setAlertMessage('');

    try {
  
      let gap;
      try {
        gap = transformToKeywordFrequencyMap(formData.semanticGap);
      } catch (transformError) {
        console.error('Error transforming semantic gap data:', transformError);
        setAlertMessage(t('Erreur dans le format du GAP sémantique'));
        setAlertType('danger');
        setIsLoading(false);
        return;
      }

      
      dispatch(
        setRedactionData({
          keyword: formData.keyword,
          url: formData.url,
          keywords: formData.semanticGap,
          semanticGap: gap,
          internalLinking: formData.internalLinking,
          isDataAvailable: true,
        })
      );

 
      onClose();

      setIsReadyToRedirect(true);

     
      setFormData({
        keyword: '',
        url: '',
        semanticGap: '',
        internalLinking: '',
      });
      setErrors({});
      setAlertMessage('');
      setSemanticGapValidation({ isValid: false, message: '', isChecked: false });
    } catch (error) {
      console.error('Error in form submission:', error);
      setAlertMessage(
        error.message || t('Erreur lors de la soumission du formulaire')
      );
      setAlertType('danger');
    } finally {
      setIsLoading(false);
    }
  };

 
  const handleKeywordsGenerated = () => {
    
    setFormData((prev) => ({
      ...prev,
      semanticGap: combinedKeywords || prev.semanticGap,
      internalLinking: websites || prev.internalLinking,
    }));

   
    if (combinedKeywords) {
      const validation = validateSemanticGapFormat(combinedKeywords);
      setSemanticGapValidation(validation);
    }

 
    if (isSuccess && errorSuccessMsg) {
      setAlertMessage(errorSuccessMsg);
      setAlertType('success');
    } else if (!isSuccess && errorSuccessMsg) {
      setAlertMessage(errorSuccessMsg);
      setAlertType('danger');
    }

 
    setErrorSuccess(false);
    setErrorSuccessMsg('');
    setIsSuccess(false);
  };

 
  React.useEffect(() => {
    if (errorSuccess) {
      handleKeywordsGenerated();
    }
  }, [errorSuccess, isSuccess, errorSuccessMsg, combinedKeywords, websites]);

  const handleModalClose = () => {
    if (isLoading) return;

    setFormData({
      keyword: '',
      url: '',
      semanticGap: '',
      internalLinking: '',
    });
    setErrors({});
    setAlertMessage('');
    setSemanticGapValidation({ isValid: false, message: '', isChecked: false });
    setKeywords('');
    setCombinedKeywords('');
    setCombinedKeywordsList([]);
    setWebsites('');
    setErrorSuccessMsg('');
    setIsSuccess(false);
    setErrorSuccess(false);

    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleModalClose}
      size="lg"
      className="redaction-modal"
      backdrop={isLoading || isRetrieving ? 'static' : true}
      keyboard={!isLoading && !isRetrieving}
    >
      <ModalHeader
        toggle={!isLoading && !isRetrieving ? handleModalClose : undefined}
      >
        {t('Nouvelle Rédaction')}
      </ModalHeader>

      <Form onSubmit={handleSubmit}>
        <ModalBody>
          {alertMessage && (
            <Alert color={alertType} className="mb-3">
              {alertMessage}
            </Alert>
          )}

          <FormGroup>
            <Label for="keyword" className="required-field">
              {t('Mots clé')}
            </Label>
            <Input
              type="text"
              id="keyword"
              name="keyword"
              value={formData.keyword}
              onChange={handleInputChange}
              placeholder={t('Entrez le mot clé principal')}
              disabled={isLoading || isRetrieving}
              invalid={!!errors.keyword}
            />
            {errors.keyword && (
              <div className="invalid-feedback d-block">{errors.keyword}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="url">{t('Url de la page')}</Label>
            <Input
              type="text"
              id="url"
              name="url"
              value={formData.url}
              onChange={handleInputChange}
              placeholder={t('Entrez l url')}
              disabled={isLoading || isRetrieving}
              invalid={!!errors.url}
            />
            {errors.url && (
              <div className="invalid-feedback d-block">{errors.url}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="semanticGap" className="required-field">
              {t('GAP sémantique')}
              <span id="gapTooltip" className="ms-2" style={{ cursor: "pointer", color: "#ef4444" }}>ⓘ</span>
            </Label>
            <Input
              type="textarea"
              id="semanticGap"
              name="semanticGap"
              value={formData.semanticGap}
              onChange={handleInputChange}
              placeholder={t(
                'keyword1 (2)\nkeyword2 (1)\nkeyword3 (1)\nkeyword4 (2)'
              )}
              disabled={isLoading || isRetrieving}
              invalid={semanticGapValidation.isChecked && !semanticGapValidation.isValid}
              valid={semanticGapValidation.isChecked && semanticGapValidation.isValid}
              rows="8"
              className="semantic-gap-textarea"
            />
            
         
            {semanticGapValidation.isChecked && semanticGapValidation.message && (
              <div 
                className={`mt-1 small ${
                  semanticGapValidation.isValid 
                    ? 'text-success' 
                    : 'text-danger'
                }`}
                style={{ fontSize: '0.875rem' }}
              >
                {semanticGapValidation.message}
              </div>
            )}

            {errors.semanticGap && (
              <div className="invalid-feedback d-block">
                {errors.semanticGap}
              </div>
            )}

            <UncontrolledTooltip
                placement="right"
                target="gapTooltip"
                className="custom-redac-tooltip"
            >
              {t('Saisissez chaque mot-clé suivi de sa fréquence entre parenthèses, séparés par une virgule ou un retour à la ligne. \n Exemple :\n chaussures(3), robe(2), pantalon(1)')}
            </UncontrolledTooltip>

            <div className="retrieve-button-container">
              <KeywordGenerationButton
                t={t}
                onGenerateKeywords={() => {
                  keywordsAutoGeneration(
                    orderId,
                    formData.keyword,
                    orderSiloName,
                    formData.url,
                    setKeywords,
                    setCombinedKeywords,
                    setCombinedKeywordsList,
                    setWebsites,
                    setErrorSuccessMsg,  
                    setIsSuccess,  
                    setErrorSuccess, 
                    t,
                    setIsRetrieving
                  );
                }}
              />
            </div>
          </FormGroup>

          <FormGroup>
            <Label for="internalLinking">
              {t('Maillage interne')}
            </Label>
            <Input
              type="textarea"
              id="internalLinking"
              name="internalLinking"
              value={formData.internalLinking}
              onChange={handleInputChange}
              placeholder={t('Introduisez le maillage interne')}
              rows="3"
              disabled={isLoading || isRetrieving}
            />
          </FormGroup>
        </ModalBody>

        <ModalFooter>
          <Button
            color="secondary"
            type="button"
            onClick={handleModalClose}
            disabled={isLoading || isRetrieving}
          >
            {t('Annuler')}
          </Button>
          <Button
            color="primary"
            type="submit"
            disabled={isLoading || isRetrieving || !isFormValid()}
            style={{
              opacity: (!isFormValid() && !isLoading && !isRetrieving) ? 0.6 : 1
            }}
          >
            {isLoading ? (
              <>
                <Spinner size="sm" className="me-1" />
                {t('Traitement...')}
              </>
            ) : (
              t('Commencer la rédaction')
            )}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default RedactionModal;
